import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  J: () => (/* binding */ IconBenefitsWaterrepellent)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconBenefitsWaterrepellent.tsx


const IconBenefitsWaterrepellent = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-waterrepellent-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Repellent Icon' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -218.000000)" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Water-Repellent", transform: "translate(508.000000, 219.000000)" }, { children: (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Repellent-Icon" }, { children: [(0,jsx_runtime.jsx)("path", { d: "M10,28 L28,10", id: "Stroke-3", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M13,29 L29,13", id: "Stroke-5", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M16.5553703,14.6036015 C17.1254918,15.1729607 17.150737,16.0725763 16.6114708,16.6117846 C16.0722046,17.1502918 15.1724925,17.1257505 14.6030723,16.5556901 C14.0329508,15.986331 13,13 13,13 C13,13 15.98595,14.0335412 16.5553703,14.6036015 Z", id: "Stroke-7", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M19.5553703,7.603461 C20.1254918,8.1734714 20.150737,9.07230699 19.6114708,9.61146812 C19.0722046,10.1506293 18.1724925,10.1253889 17.6030723,9.55607966 C17.0329508,8.98606925 16,6 16,6 C16,6 18.98595,7.03415171 19.5553703,7.603461 Z", id: "Stroke-9", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M9.55600183,17.6036015 C10.1254109,18.1729607 10.1506557,19.0725763 9.61140001,19.6117846 C9.0728456,20.1502918 8.17315119,20.1257505 7.60304086,19.5556901 C7.03293053,18.986331 6,16 6,16 C6,16 8.9858915,17.0335412 9.55600183,17.6036015 Z", id: "Stroke-11", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M7.57667783,10.5325474 C8.14110739,11.0969769 8.14110739,12.0122483 7.57667783,12.5766778 C7.01224827,13.1411074 6.09697693,13.1411074 5.53328134,12.5766778 C4.9681178,12.0122483 4,9 4,9 C4,9 7.01224827,9.9681178 7.57667783,10.5325474 Z", id: "Stroke-13", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M23.9707454,9 C25.3430849,10.37238 25.3430849,12.5978036 23.9707454,13.9701836 C22.5984059,15.3432721 20.373048,15.3432721 19,13.9701836", id: "Stroke-15", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M23,8 L24,9", id: "Stroke-17", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("polyline", { id: "Stroke-19", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round", points: "23 10 23 8 25 8" }), (0,jsx_runtime.jsx)("path", { d: "M13.9707454,19 C15.3430849,20.37238 15.3430849,22.5978036 13.9707454,23.9701836 C12.5984059,25.3432721 10.373048,25.3432721 9,23.9701836", id: "Stroke-21", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M8,23 L9,24", id: "Stroke-23", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("polyline", { id: "Stroke-25", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round", points: "8 25 8 23 10 23" }), (0,jsx_runtime.jsx)("path", { d: "M15.0018463,0.519995048 C14.9773314,0.519995048 14.9535593,0.519995048 14.9283015,0.519995048 C6.94385832,0.560108951 0.480084618,7.0875325 0.519457104,15.071685 C0.559572468,23.0313235 7.04786112,29.480005 14.9988748,29.480005 C15.0226469,29.480005 15.0479047,29.480005 15.0716767,29.480005 C18.9398378,29.4606909 22.5687925,27.9363625 25.2906942,25.1885601 C28.0118531,22.4400149 29.4998359,18.7963353 29.4805211,14.928315 C29.4612063,11.0602947 27.9375654,7.43221493 25.1889201,4.71041228 C22.4581038,2.00643803 18.8425209,0.519995048 15.0018463,0.519995048 Z M14.9988748,30 C6.76185343,30.0007429 0.0403013706,23.3202922 0.000186006853,15.0746564 C-0.040672234,6.80302092 6.65487913,0.0408567537 14.92533,0 L15.0018463,0 C18.9806961,0 22.7255396,1.53992819 25.5544156,4.3412158 C28.4018636,7.16033181 29.9804774,10.9191532 29.9997922,14.9260864 C30.0205928,18.9322768 28.4791228,22.706698 25.6599041,25.5540423 C22.8406855,28.4013867 19.0809845,29.979943 15.0746483,30 L14.9988748,30 Z", id: "Fill-19", stroke: "#00174F", strokeWidth: 0.5, fill: "#00285E" })] })) })) })) }))] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-waterrepellent-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Repellent Icon' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -218.000000)" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Water-Repellent", transform: "translate(508.000000, 219.000000)" }, { children: (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Repellent-Icon" }, { children: [(0,jsx_runtime.jsx)("path", { d: "M10,28 L28,10", id: "Stroke-3", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M13,29 L29,13", id: "Stroke-5", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M16.5553703,14.6036015 C17.1254918,15.1729607 17.150737,16.0725763 16.6114708,16.6117846 C16.0722046,17.1502918 15.1724925,17.1257505 14.6030723,16.5556901 C14.0329508,15.986331 13,13 13,13 C13,13 15.98595,14.0335412 16.5553703,14.6036015 Z", id: "Stroke-7", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M19.5553703,7.603461 C20.1254918,8.1734714 20.150737,9.07230699 19.6114708,9.61146812 C19.0722046,10.1506293 18.1724925,10.1253889 17.6030723,9.55607966 C17.0329508,8.98606925 16,6 16,6 C16,6 18.98595,7.03415171 19.5553703,7.603461 Z", id: "Stroke-9", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M9.55600183,17.6036015 C10.1254109,18.1729607 10.1506557,19.0725763 9.61140001,19.6117846 C9.0728456,20.1502918 8.17315119,20.1257505 7.60304086,19.5556901 C7.03293053,18.986331 6,16 6,16 C6,16 8.9858915,17.0335412 9.55600183,17.6036015 Z", id: "Stroke-11", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M7.57667783,10.5325474 C8.14110739,11.0969769 8.14110739,12.0122483 7.57667783,12.5766778 C7.01224827,13.1411074 6.09697693,13.1411074 5.53328134,12.5766778 C4.9681178,12.0122483 4,9 4,9 C4,9 7.01224827,9.9681178 7.57667783,10.5325474 Z", id: "Stroke-13", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M23.9707454,9 C25.3430849,10.37238 25.3430849,12.5978036 23.9707454,13.9701836 C22.5984059,15.3432721 20.373048,15.3432721 19,13.9701836", id: "Stroke-15", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M23,8 L24,9", id: "Stroke-17", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("polyline", { id: "Stroke-19", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round", points: "23 10 23 8 25 8" }), (0,jsx_runtime.jsx)("path", { d: "M13.9707454,19 C15.3430849,20.37238 15.3430849,22.5978036 13.9707454,23.9701836 C12.5984059,25.3432721 10.373048,25.3432721 9,23.9701836", id: "Stroke-21", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("path", { d: "M8,23 L9,24", id: "Stroke-23", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round" }), (0,jsx_runtime.jsx)("polyline", { id: "Stroke-25", stroke: "#00285E", strokeWidth: 0.75, strokeLinecap: "round", strokeLinejoin: "round", points: "8 25 8 23 10 23" }), (0,jsx_runtime.jsx)("path", { d: "M15.0018463,0.519995048 C14.9773314,0.519995048 14.9535593,0.519995048 14.9283015,0.519995048 C6.94385832,0.560108951 0.480084618,7.0875325 0.519457104,15.071685 C0.559572468,23.0313235 7.04786112,29.480005 14.9988748,29.480005 C15.0226469,29.480005 15.0479047,29.480005 15.0716767,29.480005 C18.9398378,29.4606909 22.5687925,27.9363625 25.2906942,25.1885601 C28.0118531,22.4400149 29.4998359,18.7963353 29.4805211,14.928315 C29.4612063,11.0602947 27.9375654,7.43221493 25.1889201,4.71041228 C22.4581038,2.00643803 18.8425209,0.519995048 15.0018463,0.519995048 Z M14.9988748,30 C6.76185343,30.0007429 0.0403013706,23.3202922 0.000186006853,15.0746564 C-0.040672234,6.80302092 6.65487913,0.0408567537 14.92533,0 L15.0018463,0 C18.9806961,0 22.7255396,1.53992819 25.5544156,4.3412158 C28.4018636,7.16033181 29.9804774,10.9191532 29.9997922,14.9260864 C30.0205928,18.9322768 28.4791228,22.706698 25.6599041,25.5540423 C22.8406855,28.4013867 19.0809845,29.979943 15.0746483,30 L14.9988748,30 Z", id: "Fill-19", stroke: "#00174F", strokeWidth: 0.5, fill: "#00285E" })] })) })) })) }))] })));
};

})();

var __webpack_exports__IconBenefitsWaterrepellent = __webpack_exports__.J;
export { __webpack_exports__IconBenefitsWaterrepellent as IconBenefitsWaterrepellent };
